<template>
  <div :class="[!context.isMobile ? `pb-2` : `pb-3`]">
    <div
      class="relative flex h-8 items-center rounded border border-menu-input-border bg-menu-input focus-within:border-blue-500"
    >
      <div class="grid size-8 place-items-center">
        <MagnifyingGlassIcon class="size-4 text-menu-muted-foreground" />
      </div>

      <DropdownMenuFilter
        v-if="!context.isMobile"
        v-model="modelValue"
        auto-focus
        :placeholder="props.placeholder ?? 'Search'"
        class="h-full grow border-0 bg-transparent px-0 text-sm text-current placeholder:text-menu-muted-foreground focus:outline-none focus:ring-0"
      />
      <input
        v-else
        ref="nativeInput"
        v-model="modelValue"
        type="text"
        :placeholder="props.placeholder ?? 'Search'"
        class="h-full grow border-0 bg-transparent px-0 text-sm text-current placeholder:text-menu-muted-foreground focus:outline-none focus:ring-0"
      />

      <div class="flex items-center pr-2">
        <button
          v-if="modelValue"
          type="button"
          aria-label="Clear"
          class="-mr-2 grid size-8 place-items-center text-menu-muted-foreground transition-colors hover:text-white"
          @click="modelValue = ''"
        >
          <XMarkIcon class="size-4" />
        </button>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { DropdownMenuFilter } from "reka-ui";
import { onMounted, useTemplateRef } from "vue";

import MagnifyingGlassIcon from "@/icons/heroicons/magnifying-glass-micro.svg";
import XMarkIcon from "@/icons/heroicons/x-mark-micro.svg";

import { inject } from "./context";

const context = inject();

const props = defineProps<{
  placeholder?: string;
}>();

const modelValue = defineModel<string>({ default: "" });

const nativeInput = useTemplateRef("nativeInput");

onMounted(() => {
  if (context.isMobile) {
    nativeInput.value?.focus();
  }
});
</script>
